import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from 'widgets/onboarding/controller';

// Use throughout widgets instead of plain `useDispatch` and `useSelector`
export const useWidgetDispatch = () => useDispatch<AppDispatch>();
export const useWidgetSelector: TypedUseSelectorHook<RootState> = useSelector;
